import { create } from "zustand";
//--------------------------------------------------------------------------------------------
import { getTimeStamp } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export const useMyStore =  create(set => ({
    // ---- Auth ----
    isAuthenticated: false,
    setAuthenticated: (bool) => set({isAuthenticated: bool}), 
    // ---- User Info ----
    user: { coords: [37.6148754, -122.0874473], accuracy: 0 }, 
    setUserInfo: (obj) => set(state => ({user: {...state.user, ...obj}})), 
    // ---- System Loader ----
    showLoader: false,
    setShowLoader: (bool) => set({showLoader: bool}), 
    // ---- Main style sates ----
    mainMenuStyle: null, 
    setMainMenuStyle: (style) => set({mainMenuStyle: style}), 
    mapFull: false, 
    setMapFull: (bool) => set({mapFull: bool}),     
    // ---- User Data ----
    // -- outside service --
    outsideserviceLocatorDivisions: {updatedAt: null, data: []}, 
    setOutsideserviceLocatorDivisions: (data, updatedAt) => set(state => ({outsideserviceLocatorDivisions: {...state.outsideserviceLocatorDivisions, data, updatedAt: updatedAt ?? state.outsideserviceLocatorDivisions.updatedAt, timeStamp: getTimeStamp()}})), 
    outsideserviceLocatorForms: {updatedAt: null}, 
    setOutsideserviceLocatorForms: (week, data, updatedAt) => set(state => ({
        outsideserviceLocatorForms: {...state.outsideserviceLocatorForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceLocatorForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideserviceStandbyForms: {updatedAt: null}, 
    setOutsideserviceStandbyForms: (week, data, updatedAt) => set(state => ({
        outsideserviceStandbyForms: {...state.outsideserviceStandbyForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceStandbyForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideserviceDailyForms: {updatedAt: null}, 
    setOutsideserviceDailyForms: (week, data, updatedAt) => set(state => ({
        outsideserviceDailyForms: {...state.outsideserviceDailyForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceDailyForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideserviceEotForms: {updatedAt: null}, 
    setOutsideserviceEotForms: (week, data, updatedAt) => set(state => ({
        outsideserviceEotForms: {...state.outsideserviceEotForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceEotForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideservicePotForms: {updatedAt: null}, 
    setOutsideservicePotForms: (week, data, updatedAt) => set(state => ({
        outsideservicePotForms: {...state.outsideservicePotForms, [week]: data, updatedAt: updatedAt ?? state.outsideservicePotForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideserviceIndividualDailyForms: {updatedAt: null}, 
    setOutsideserviceIndividualDailyForms: (week, data, updatedAt) => set(state => ({
        outsideserviceIndividualDailyForms: {...state.outsideserviceIndividualDailyForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceIndividualDailyForms.updatedAt, timeStamp: getTimeStamp()}
    })),  
    outsideserviceIndividualPotForms: {updatedAt: null}, 
    setOutsideserviceIndividualPotForms: (week, data, updatedAt) => set(state => ({
        outsideserviceIndividualPotForms: {...state.outsideserviceIndividualPotForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceIndividualPotForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    outsideserviceIndividualEotForms: {updatedAt: null}, 
    setOutsideserviceIndividualEotForms: (week, data, updatedAt) => set(state => ({
        outsideserviceIndividualEotForms: {...state.outsideserviceIndividualEotForms, [week]: data, updatedAt: updatedAt ?? state.outsideserviceIndividualEotForms.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- approval --
    approvals: {updatedAt: null, data: []}, 
    setApprovals: (data, updatedAt) => set(state => ({approvals: {...state.approvals, data, updatedAt: updatedAt ?? state.approvals.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- billings --
    billings: {updatedAt: null, data: []}, 
    setBillings: (weekStart, weekEnd, data, updatedAt) => set(state => ({
        billings: {...state.billings, data, updatedAt: updatedAt ?? state.billings.updatedAt, weekStart, weekEnd, timeStamp: getTimeStamp()}
    })), 
    billingPurchases: {updatedAt: null}, 
    setBillingPurchases: (projectHashKey, data, updatedAt) => set(state => ({
        billingPurchases: {...state.billingPurchases, [projectHashKey]: data, updatedAt: updatedAt ?? state.billingPurchases.updatedAt, timeStamp: getTimeStamp()}
    })), 
    billingWorkLogs: {updatedAt: null}, 
    setBillingWorkLogs: (projectHashKey, data, updatedAt) => set(state => ({
        billingWorkLogs: {...state.billingWorkLogs, [projectHashKey]: data, updatedAt: updatedAt ?? state.billingWorkLogs.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- calendar --
    calendarWeek: null, 
    setCalendarWeek: week => set(() => ({calendarWeek: week})), 
    calendarWeeks: {updatedAt: null, data: []}, 
    setCalendarWeeks: (data, updatedAt) => set(state => ({calendarWeeks: {...state.calendarWeeks, data, updatedAt: updatedAt ?? state.calendarWeeks.updatedAt, timeStamp: getTimeStamp()}})), 
    calendarWorkLogs: {updatedAt: null}, 
    setCalendarWorkLogs: (week, data, updatedAt) => set(state => ({
        calendarWorkLogs: {...state.calendarWorkLogs, [week]: data, updatedAt: updatedAt ?? state.calendarWorkLogs.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- leads --
    leads: {updatedAt: null, data: []}, 
    setLeads: (data, updatedAt) => set(state => ({leads: {...state.leads, data, updatedAt: updatedAt ?? state.leads.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- opportunities --
    opportunities: {updatedAt: null, data: []}, 
    setOpportunities: (data, updatedAt) => set(state => ({opportunities: {...state.opportunities, data, updatedAt: updatedAt ?? state.opportunities.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- contacts --
    contacts: {updatedAt: null, data: []}, 
    setContacts: (data, updatedAt) => set(state => ({contacts: {...state.contacts, updatedAt: updatedAt ?? state.contacts.updatedAt, data, timeStamp: getTimeStamp()}})), 
    contactDetails: {updatedAt: null}, 
    setContactDetails: (contactHashKey, data, updatedAt) => set(state => ({
        contactDetails: {...state.contactDetails, [contactHashKey]: data, updatedAt: updatedAt ?? state.contactDetails.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- organizations --
    organizations: {updatedAt: null, data: []}, 
    setOrganizations: (data, updatedAt) => set(state => ({organizations: {...state.organizations, updatedAt: updatedAt ?? state.organizations.updatedAt, data, timeStamp: getTimeStamp()}})), 
    organizationDetails: {updatedAt: null}, 
    setOrganizationDetails: (organizationHashKey, data, updatedAt) => set(state => ({
        organizationDetails: {...state.organizationDetails, [organizationHashKey]: data, updatedAt: updatedAt ?? state.organizationDetails.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- fleets --
    fleets: {updatedAt: null, data: []}, 
    setFleets: (data, updatedAt) => set(state => ({fleets: {...state.fleets, updatedAt: updatedAt ?? state.fleets.updatedAt, data, timeStamp: getTimeStamp()}})), 
    fleetDetails: {updatedAt: null}, 
    setFleetDetails: (truckNumber, data, updatedAt) => set(state => ({
        fleetDetails: {...state.fleetDetails, [truckNumber]: data, updatedAt: updatedAt ?? state.fleetDetails.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- per diem --
    perDiems: {updatedAt: null, data: []}, 
    setPerDiems: (weekStart, weekEnd, data, updatedAt) => set(state => ({
        perDiems: {...state.perDiems, data, updatedAt: updatedAt ?? state.perDiems.updatedAt, weekStart, weekEnd, timeStamp: getTimeStamp()}
    })), 
    perDiemUserNames: {updatedAt: null, data: []}, // email, userName, department, purchases * , outside, btlNumber
    setPerDiemUserNames: (data, updatedAt) => set(state => ({perDiemUserNames: {...state.perDiemUserNames, data, updatedAt: updatedAt ?? state.perDiemUserNames.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- vendors --
    vendors: {updatedAt: null, data: []}, 
    setVendors: (data, updatedAt) => set(state => ({
        vendors: {...state.vendors, data, updatedAt: updatedAt ?? state.vendors.updatedAt, timeStamp: getTimeStamp()}
    })), 
    vendorDetails: {updatedAt: null}, 
    setVendorDetails: (vendorHashkey, data, updatedAt) => set(state => ({
        vendorDetails: {...state.vendorDetails, [vendorHashkey]: data, updatedAt: updatedAt ?? state.vendorDetails.updatedAt, timeStamp: getTimeStamp()}
    })), 
    // -- hours --
    hoursWeek: null, 
    setHoursWeek: week => set(() => ({hoursWeek: week})), 
    hoursWeeks: {updatedAt: null, data: []}, 
    setHoursWeeks: (data, updatedAt) => set(state => ({hoursWeeks: {...state.hoursWeeks, data, updatedAt: updatedAt ?? state.hoursWeeks.updatedAt, timeStamp: getTimeStamp()}})), 
    hoursWorkLogs: {updatedAt: null, data: []}, 
    setHoursWorkLogs: (date, data, updatedAt) => set(state => ({hoursWorkLogs: {...state.hoursWorkLogs, [date]: data, updatedAt: updatedAt ?? state.hoursWorkLogs.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- map --
    mapWorkLogs: {updatedAt: null, data: []}, 
    setMapLogs: (date, data, updatedAt) => set(state => ({mapWorkLogs: {...state.mapWorkLogs, [date]: data, updatedAt: updatedAt ?? state.mapWorkLogs.updatedAt, timeStamp: getTimeStamp()}})), 
    mapTrucks: {updatedAt: null, data: []}, 
    setMapTrucks: (data, updatedAt) => set(state => ({mapTrucks: {...state.mapTrucks, data, updatedAt: updatedAt ?? state.mapTrucks.updatedAt, timeStamp: getTimeStamp()}})), 
    // -- common --
    projectNames: {updatedAt: null, data: []}, // projectHashKey, projectName
    setProjectNames: (data, updatedAt) => set(state => ({projectNames: {...state.projectNames, data, updatedAt: updatedAt ?? state.projectNames.updatedAt, timeStamp: getTimeStamp()}})), 
    userNames: {updatedAt: null, data: []}, // email, userName
    setUserNames: (data, updatedAt) => set(state => ({userNames: {...state.userNames, data, updatedAt: updatedAt ?? state.userNames.updatedAt, timeStamp: getTimeStamp()}})), 
    organizationNames: {updatedAt: null, data: []}, // organizationHashKey, organizationName
    setOrganizationNames: (data, updatedAt) => set(state => ({organizationNames: {...state.organizationNames, data, updatedAt: updatedAt ?? state.organizationNames.updatedAt, timeStamp: getTimeStamp()}})), 
    contactNames: {updatedAt: null, data: []}, // contactHashKey, contactName
    setContactNames: (data, updatedAt) => set(state => ({contactNames: {...state.contactNames, data, updatedAt: updatedAt ?? state.contactNames.updatedAt, timeStamp: getTimeStamp()}})), 
}));